export const id = {
  title: 'Tutupan lahan 2000-2020',
  subtitle: 'UMD',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Fungsi',
      value: 'Peta penggunaan lahan dan tutupan lahan global untuk tahun 2000 dan 2020',
    },
    {
      label: 'Resolusi',
      value: '30 meter',
    },
    {
      label: 'Cakupan geografis',
      value: 'Global',
    },
    {
      label: 'Sumber',
      value: 'UMD',
    },
    {
      label: 'Frekuensi pembaruan',
      value: '',
    },
    {
      label: 'Tanggal konten',
      value: '',
    },
    {
      label: 'Peringatan',
      value:
        '- Pemetaan tutupan lahan dibatasi oleh ketersediaan data langit cerah Landsat. Ketidaklengkapan deret waktu pengamatan Landsat menurunkan akurasi peta di wilayah dengan tutupan awan yang persisten. \n- Pemetaan kelas tutupan lahan diskrit dalam lanskap heterogen dibatasi oleh proporsi piksel campuran yang tinggi pada resolusi spasial Landsat. Sebagian besar kelas LULC memiliki akurasi peta yang lebih tinggi di area homogen yang luas dibandingkan dengan lanskap yang terfragmentasi dan tepi tambalan kelas. \n- Kesamaan spektral antara kelas LCLU yang berbeda dapat menghalangi diskriminasi kelas.\n- Produk tinggi hutan memiliki masalah terkait kualitas data GEDI dan ketersediaan data Landsat. Perubahan kecil dalam ketinggian hutan antara tahun 2000 dan 2020 mungkin tidak menunjukkan perubahan struktur hutan yang sebenarnya tetapi mewakili kebisingan dalam output model. \n- Kelas dinamis (kehilangan dan keuntungan kelas LCLU) memiliki akurasi yang lebih rendah dibandingkan dengan peta statis. \n- Perkiraan berbasis peta tidak memadai untuk pelaporan nasional dan internasional karena variabilitas spasial dan temporal ketidakpastian peta yang tidak diketahui.',
    },
    {
      label: 'Lisensi',
      value: 'Lisensi Atribusi Creative Commons (https://glad.umd.edu/dataset/GLCLUC2020)',
    },
  ],
  overview: {
    label: 'Ikhtisar',
    value:
      'Peta penggunaan lahan dan tutupan lahan global dibuat oleh laboratorium Global Land Analysis and Discovery Lab (GLAD), dan data tersedia pada resolusi spasial 30 m untuk tahun 2000 dan 2020. Laboratorium GLAD menggunakan [Landsat Analysis Ready Data (GLAD ARD)](https://glad.umd.edu/ard) yang konsisten secara spasiotemporal untuk mengukur perubahan luas dan ketinggian hutan, lahan pertanian, lahan terbangun, air permukaan, dan luas salju dan es abadi selama periode dua puluh tahun. Setiap produk tematik diturunkan secara independen menggunakan alat pembelajaran mesin yang canggih, dikalibrasi secara lokal dan regional. Kumpulan data divalidasi menggunakan pengambilan sampel statistik yang menegaskan akurasinya yang tinggi. Laboratorium Global Land Analysis and Discovery Lab (GLAD) di Departemen Ilmu Geografi UMD menyelidiki metode, penyebab, dan dampak perubahan permukaan tanah global. Citra pengamatan bumi adalah sumber data utama, dan luas serta perubahan tutupan lahan adalah topik utama yang menarik. GLAD bercita-cita untuk menghasilkan wawasan sains baru mengenai sumber daya lahan, mendidik generasi berikutnya dari ilmuwan perubahan lahan berbasis penginderaan jauh, dan menyebarluaskan kemampuan pemantauan lahan ke pengaturan operasional nasional dan internasional.',
  },
  citation: {
    label: 'Rujukan',
    value:
      'Potapov P., Hansen M.C., Pickens A., Hernandez-Serna A., Tyukavina A., Turubanova S., Zalles V., Li X., Khan A., Stolle F., Harris N., Song X.-P., Baggett A., Kommareddy I., Kommareddy A. (2022) The global 2000-2020 land cover and land use change dataset derived from the Landsat archive: first results. Frontiers in Remote Sensing. [https://doi.org/10.3389/frsen.2022.856903](https://doi.org/10.3389/frsen.2022.856903). Accessed through Resource Watch, (date). [www.resourcewatch.org](https://www.resourcewatch.org).',
  },
};
